import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — decor: a horizontal shop fascia sign authored at its
// true mounting height (spanning y = 2.2 to 2.6, above a doorway), flat
// against the wall at z = 0, facing +Z. A blank muted-red text band sits
// proud of the matte-black sign box (no letters).
const SIGN = "#2e2e30";
const BAND = "#9c4a3e";

export const shopSign = defineModel({
  id: "shop-sign",
  batchId: "modern",
  name: "Shop sign",
  tags: ["modern", "outdoor", "decor", "sign", "shop", "retail", "wall-mounted"],
  summary: "A matte-black fascia shop sign with a blank red text band.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // fascia sign box
      { geometry: new THREE.BoxGeometry(1.0, 0.4, 0.08), color: SIGN, position: [0, 2.4, 0.04] },
      // blank text band proud of the face
      { geometry: new THREE.BoxGeometry(0.8, 0.16, 0.02), color: BAND, position: [0, 2.4, 0.09] },
    ];
  },
  animations: [],
});
